import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TableModule, TableLazyLoadEvent } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BusinessUnitsService } from '../business-units.service';
import { BusinessUnit } from '../business-unit.model';
import { Page } from '../../../models/page-wrapper.model';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-business-units-list',
  templateUrl: './business-units-list.component.html',
  styleUrl: './business-units-list.component.css',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TableModule,
    ButtonModule,
    ToastModule,
    ConfirmDialogModule,
    RouterModule,
  ],
  providers: [ConfirmationService, MessageService],
})
export class BusinessUnitsListComponent implements OnInit {
  businessUnits: BusinessUnit[] = [];
  totalRecords = 0;
  isLoading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private businessUnitsService: BusinessUnitsService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadBusinessUnits();
  }

  loadBusinessUnits(
    event?: TableLazyLoadEvent,
    isExport: boolean = false,
    callback?: (businessUnits: BusinessUnit[]) => void
  ) {
    this.isLoading = true;
    let params: any;

    if (isExport) {
      params = {
        page: 0,
        size: 2000,
      };
    } else {
      const size = event?.rows ?? 10;
      const page = event?.first ? Math.floor(event.first / size) : 0;
      params = {
        page,
        size,
      };
    }

    this.businessUnitsService.getAllBusinessUnits(params).subscribe({
      next: (page: Page<BusinessUnit>) => {
        this.businessUnits = page.content;
        this.totalRecords = page.totalElements;
        this.isLoading = false;
        if (callback) {
          callback(page.content);
        }
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load business units.',
        });
      },
    });
  }

  deleteBusinessUnit(businessUnit : BusinessUnit): void {
     this.confirmationService.confirm({
      message: `Are you sure you want to delete ${businessUnit.businessUnitName}?`,
      header: 'Confirm Deletion',
      icon: 'pi pi-exclamation-triangle',

      acceptLabel: 'Yes, Delete',
      rejectLabel: 'Cancel',

      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-success',

      accept: () => {
        this.businessUnitsService.deleteBusinessUnit(businessUnit.id).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: `Business Unit Deleted successfully.`,
            });
            setTimeout(() => {
              this.loadBusinessUnits();
            }, 500);
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `Failed to Delete Business Unit.`,
            });
            console.error(err);
          },
        });
      },
    });
  }

  createBusinessUnit() {
    this.router.navigate(
      ['.', { outlets: { canvasOutlet: ['businessUnit', 'create'] } }],
      { relativeTo: this.route.parent?.parent }
    );
  }

  editBusinessUnit(id: number): void {
    this.router.navigate(
      ['.', { outlets: { canvasOutlet: ['businessUnit', 'edit', id] } }],
      { relativeTo: this.route.parent?.parent }
    );
  }
  
  exportExcel(): void {
    this.loadBusinessUnits(undefined, true, (businessUnits: BusinessUnit[]) => {
      const dataToExport = businessUnits.map((businessUnit) => ({
        'Business Unit Name': businessUnit.businessUnitName,
        'Business Unit Code': businessUnit.businessUnitCode,
      }));

      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'business-units');

      XLSX.writeFile(wb, 'Business_Unit_Export.xlsx');
    });
  }
}
